export class Filter {
  Group: string;
  Header: string;
  Operator: string;
  Value: any;
}
